

































































































































































































































































































































import { Component, Vue, Ref, Prop, Watch } from "vue-property-decorator";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import ClientPanel, { isCurrentClientPanel } from "@/data/models/ClientPanel";
import { DeviceTemplate, selectedPowerConsumptionMode } from "@/data/models/DeviceTemplate";
import {
  DevicePowerUsageType,
  getDeviceAttributeTypeFromDeviceTemplate,
  getDevicePowerUsageTypeByName,
  getDevicePowerUsageNameByType,
  DeviceAttributeType,
} from "@/data/models/DeviceAttribute";
import {
  isQrCodeValid,
  isInventoryNumberValid,
  parsePowerConsumption,
  isManufacturerValid,
  isSerialNumberValid,
  isElectricityMeterManufacturerValid,
  isElectricityMeterNumberValid,
  isNoteValid,
} from "@/data/models/BaseDeviceInfo";
import {
  getIresDevicePowerUsageName,
  getIresDeviceManufacturer,
  getIresDeviceElectricityMeterManufacturer,
  getIresDevicePowerConsumptionPerHour
} from "@/data/models/IresDevice";
import { getBranchName } from "@/data/models/Branch";
import { findBranch, getBranchesOfClient, getVehicleManagementAccess } from "@/data/repository/ClientRepository";
import { formatDateShort, timestampToDate } from "@/utils/DateFormatter";
import { UserModule } from "@/store/modules/UserModule";
import { getBranchesVisibleToActiveUser, getReactiveActiveUser } from "@/data/repository/UserRepository";
import { 
  updateDeviceById, 
  findDevicesWithInventoryNumber, 
  findDevicesWithQrCode, 
  getMaxInternalDeviceNumber, 
  saveDevices, 
  getClientDevicesRef 
} from "@/data/repository/GenericDeviceRepository";
import router from "@/router/router";
import { generateInput, GenericDevice, MAX_QR_CODE_LENGTH } from "@/data/models/GenericDevice";
import PickerDialogComponent from "../common/PickerDialog.vue";
import DatePickerCompoment from "../common/DatePicker.vue";
import { GenericDeviceProjectAssignment, extractPowerConsumptionInput } from "@/data/models/GenericDeviceAssignment";
import { 
  filterOutUndefined, 
  generateRandomUuid,
  getReleasedQrCode,
  getUpdatedIdsAfterDeletion,
  isNotEmpty,
  roundWithPrecision 
} from "@/utils/Utils";
import { 
  getClientPanelsRef, 
  updateClientPanel, 
  findPanelsWithInventoryNumber, 
  findPanelsWithQrCode 
} from "@/data/repository/ClientPanelRepository";
import { DeviceCategoryTemplate } from "@/data/models/DeviceCategoryTemplate";
import { firestore } from "firebase";
import { formatKWh } from "@/utils/LocalisationHelper";
import { isDeviceDeleted, isDeviceAvailable } from "@/utils/DeviceManagementUtils";
import { deviceCheckManagementAccess, editAllDevicesAccess } from "@/permissions/UserPermissions";
import { COLOR_ALL_DEVICES_PROJECT_LINK } from "@/utils/colors";
import { themedFill } from "@/utils/Theme";
import { removeDeviceFromVehicle } from "@/data/repository/VehicleRepository";
import Vehicle from "@/data/models/Vehicle";
import { trimDeviceCode } from "@/utils/DeviceCode";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "date-picker": DatePickerCompoment,
    picker: PickerDialogComponent,
  },
})
export default class DeviceDetailsDialog extends Vue {
  @Prop()
  clientPanel!: ClientPanel;

  @Prop()
  deviceOverview!: DeviceOverview;

  @Prop()
  deviceTemplate!: DeviceTemplate;

  @Prop()
  deviceCategory!: DeviceCategoryTemplate;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  @Prop()
  searchQuery!: string;

  currentlyOpenedDeviceKey = "CurrentOpenedDevice";
  isReadOnlyKey = "IsReadOnly";
  searchQueryKey = "SearchQuery";

  availabilityOptions = [-1, 0, 1];

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  showingErrorSnackbar = false;
  errorSnackbarText = "";

  isLoading = false;

  cachedIsReadOnly = localStorage.getItem(this.isReadOnlyKey);
  isReadOnly = this.cachedIsReadOnly ? this.cachedIsReadOnly === "true" : true;
  isEditingDeviceDetails = !this.isReadOnly;

  title = "";

  hideOpenVehicleButton = false;
  canEditQrCode = true;
  canEditPowerConsumptionPerHour = false;
  canEditDevicePowerUsageType = false;
  canEditSerialNumber = false;
  canEditManufacturer = false;
  canEditElectricityMeterManufacturer = false;

  preventClosingDialog = this.isEditingDeviceDetails;

  deviceDetails: GenericDevice | null = null;
  deviceAssignments: GenericDeviceProjectAssignment[] = [];

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  inventoryNumber: string | null | undefined = null;
  serialNumber: string | null | undefined = null;
  manufacturer: string | null | undefined = null;
  qrCode: string | null | undefined = null;
  electricityMeterManufacturer: string | null | undefined = null;
  electricityMeterNumber: string | null | undefined = null;
  acquisitionDate: firestore.Timestamp | null | undefined = null;
  lastCheckAt: firestore.Timestamp | null | undefined = null;
  nextCheck: firestore.Timestamp | null | undefined = null;
  isAvailableValue: number | null = null;
  isForDeviceCreation = false;
  branch: string | null | undefined = null;
  homeLocation: string | null | undefined = null;
  note: string | null | undefined = null;
  powerConsumptionPerHour: number | null | undefined = null;
  deviceCode: string = this.$t(this.clientPanel ? "allDevices.noQrCode" : "allDevices.qrCodeNotStored").toString();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialDeviceDetails: any = {};
  
  vehicle: Vehicle | null = null;

  errorInventoryNumber: string[] = [];
  errorPowerConsumptionPerHourError: string[] = [];
  errorInvalidQrCode: string[] = [];
  errorInvalidManufacturer: string[] = [];
  errorInvalidSerialNumber: string[] = [];
  errorInvalidElectricityMeterManufacturer: string[] = [];
  errorInvalidElectricityMeterNumber: string[] = [];
  errorInvalidNote: string[] = [];

  cancelButtonText = this.$t("common.abort").toString();
  closeButtonText = this.$t("common.close").toString();
  saveButtonText = this.$t("common.save").toString();
  editButtonText = this.$t("common.edit").toString();
  detailsButtonText = this.$t("common.details").toString();
  historyButtonText = this.$t("panelDetail.actions.history").toString();

  @Watch("deviceCode")
  onDeviceCodeChanged(value: string) {
    if (
      (
        (
          value &&
          value !== ""
        ) ||
        (
          this.initialDeviceDetails.qrCode &&
          this.initialDeviceDetails.qrCode !== ""
        )
      ) &&
      value !== this.$t(this.clientPanel ? "allDevices.noQrCode" : "allDevices.qrCodeNotStored").toString()
    ) {
      this.qrCode = value;
    }
  }

  get openProjectButtonColor() {
    return themedFill(COLOR_ALL_DEVICES_PROJECT_LINK);
  }

  get branchFormatter() {
    return (branchId: string) => {
      return getBranchName(findBranch(branchId));
    };
  }

  get branchOptions() {
    return getBranchesVisibleToActiveUser().map((branch) => branch.id);
  }

  get devicePowerUsageTypeString() {
    return this.clientPanel
      ? getIresDevicePowerUsageName(this, this.clientPanel.serialNumber)
      : getDevicePowerUsageNameByType(this, getDeviceAttributeTypeFromDeviceTemplate(this.deviceTemplate));
  }

  get devicePowerUsageType() {
    return getDevicePowerUsageTypeByName(this, this.devicePowerUsageTypeString);
  }

  get activeUser() {
    return getReactiveActiveUser();
  }

  get isAllowedToEditDevices() {
    const user = this.activeUser;

    if (!user) {
      return false;
    }

    return editAllDevicesAccess(user) && !this.isDeviceDeleted && this.isCurrentlyAssignedToThisClient;
  }
  
  get showDeviceCheckOptions() {
    const user = this.activeUser;

    if (!user) {
      return false;
    }

    return deviceCheckManagementAccess(user);
  }

  get isCurrentlyAssignedToThisClient() {
    return !this.clientPanel || this.clientPanel.panelCurrentlyAssignedToClient;
  }

  get canEditBranches() {
    return this.branchOptions.length > 0;
  }

  get canEditCurrentLocation() {
    return !this.isVehicleManagementEnabled;
  }

  get isAvailable() {
    if (this.isForDeviceCreation) {
      return true;
    }
    
    if (!this.isCurrentlyAssignedToThisClient) {
      return false; 
    }

    return this.clientPanel
      ? isDeviceAvailable(this.clientPanel)
      : isDeviceAvailable(this.deviceOverview);
  }

  get isDeviceDeleted() {
    if (this.isForDeviceCreation) {
      return false;
    }

    return isDeviceDeleted(this.clientPanel ?? this.deviceOverview);
  }

  get isHistoryAvailable() {
    return this.clientPanel
      ? true
      : this.deviceAssignments
        .filter((assignment) => {
          return assignment.assignmentEndDate !== null;
        })
        .length > 0;
  }

  get isDeviceDetailAvailable() {
    return this.clientPanel.panelCurrentlyAssignedToClient && !isDeviceDeleted(this.clientPanel);
  }

  get hasDetailsEdited() {
    return this.inventoryNumber !== this.initialDeviceDetails.inventoryNumber ||
      this.serialNumber !== this.initialDeviceDetails.serialNumber ||
      this.manufacturer !== this.initialDeviceDetails.manufacturer ||
      this.electricityMeterManufacturer !== this.initialDeviceDetails.electricityMeterManufacturer ||
      this.acquisitionDate !== this.initialDeviceDetails.acquisitionDate ||
      this.lastCheckAt !== this.initialDeviceDetails.lastCheckAt ||
      this.nextCheck !== this.initialDeviceDetails.nextCheck ||
      this.isAvailableValue !== this.initialDeviceDetails.isAvailableValue ||
      this.branch !== this.initialDeviceDetails.branch ||
      this.homeLocation !== this.initialDeviceDetails.homeLocation ||
      this.note !== this.initialDeviceDetails.note ||
      this.powerConsumptionPerHour !== this.initialDeviceDetails.powerConsumptionPerHour ||
      (
        this.qrCode !== this.initialDeviceDetails.qrCode &&
        (
          this.initialDeviceDetails.qrCode !== null ||
          this.qrCode !== ""
        )
      )
  }

  get maxQrCodeLength() {
    return MAX_QR_CODE_LENGTH;
  }

  get meterInfo() {
    if (this.clientPanel || this.deviceAssignments.length === 0) {
      return "";
    }

    const latestDeviceAssignment = this.deviceAssignments[0];
    const powerConsumptionInput = extractPowerConsumptionInput(latestDeviceAssignment.input);
    const startValue = powerConsumptionInput?.startValue;
    const endValue = powerConsumptionInput?.endValue;
    const hasStartValue = typeof startValue === "number";
    const hasEndValue = typeof endValue === "number";

    return powerConsumptionInput
      ? hasStartValue && hasEndValue
        ? this.$t("allDevices.meterInfoStartEnd", [
            formatKWh(this, roundWithPrecision(startValue, 1), 1),
            formatKWh(this, roundWithPrecision(endValue, 1), 1)
          ]).toString()
        : hasStartValue
          ? this.$t("allDevices.meterInfoStart", [
              formatKWh(this, roundWithPrecision(startValue, 1), 1),
            ]).toString()
          : ""
      : "";
  }

  get projectId() {
    return this.clientPanel
      ? this.clientPanel.currentProjectId ?? this.clientPanel.lastProjectId
      : this.deviceOverview.projectId
  }

  get vehicleId() {
    return this.clientPanel
      ? this.clientPanel.vehicleId
      : this.deviceOverview.vehicleId
  }

  get deviceLastMovedInfo() {
    if (!this.vehicleInfo || this.vehicleInfo === "") {
      return "";
    }

    const device = this.clientPanel || this.deviceOverview;
    
    const deviceLastMovedAt = device.deviceLastMoved?.recordedAt;
    if (!deviceLastMovedAt) {
      return "";
    }

    const movedAt = formatDateShort(deviceLastMovedAt).toString();
    const movedBy = UserModule.userNicknameFromRecordInfo(
      device.deviceLastMoved
    );

    if (!movedBy) {
      return movedAt;
    }

    return this.$t("deviceDetailsDialog.deviceLastMovedInfo", [movedBy, movedAt]);
  }

  get projectInfo() {
    let projectName = "";
    let projectInfo = "";

    if (!this.clientPanel && !this.deviceOverview) {
      return projectInfo;
    }

    if (this.clientPanel) {
      projectName = this.clientPanel.currentProjectName
        ? this.clientPanel.currentProjectName
        : this.clientPanel.lastProjectName
          ? this.clientPanel.lastProjectName
          : "";

      if (projectName && projectName !== "") {
        const startDate = this.clientPanel.lastProjectAssignmentTimeRange?.startDate;
        const endDate = this.clientPanel.lastProjectAssignmentTimeRange?.endDate;

        const startYear = startDate ? timestampToDate(startDate)?.getFullYear() : null;
        const endYear = endDate ? timestampToDate(endDate)?.getFullYear() : null;

        if (this.clientPanel.currentProjectAssignmentTimeRange) {
          projectInfo = this.$t("allDevices.currentProjectStartedAt", [projectName, formatDateShort(this.clientPanel.currentProjectAssignmentTimeRange?.startDate, undefined, true)]).toString();
        }
        else if (endDate && startDate) {
          const formattedStartDate = formatDateShort(startDate, undefined, true, startYear !== endYear);
          const formattedEndDate = formatDateShort(endDate, undefined, true, startYear !== endYear);

          if (formattedStartDate !== formattedEndDate) {
            projectInfo = this
              .$t("allDevices.recentlyClosedProject", [
                  projectName,
                  formattedStartDate,
                  formattedEndDate
                ])
              .toString();
          }
          else {
            projectInfo = this
              .$t("allDevices.recentlyClosedProjectAlt", [
                  projectName,
                  formattedStartDate
                ])
              .toString();
          }
        }
      }
    }
    else {
      projectName = this.deviceOverview.projectName ?? "";

      if (projectName && projectName !== "") {
        const startDate = this.deviceOverview.projectAssignmentTimeRange?.startDate;
        const endDate = this.deviceOverview.projectAssignmentTimeRange?.endDate;

        const startYear = startDate ? timestampToDate(startDate)?.getFullYear() : null;
        const endYear = endDate ? timestampToDate(endDate)?.getFullYear() : null;

        projectInfo = this.deviceOverview.currentlyAssigned && startDate
          ? this.$t("allDevices.currentProjectStartedAt", [projectName, formatDateShort(startDate, undefined, true)]).toString()
          : startDate && endDate
            ? this.
              $t("allDevices.recentlyClosedProject", [
                  projectName,
                  formatDateShort(startDate, undefined, true, startYear !== endYear),
                  formatDateShort(endDate, undefined, true, startYear !== endYear)
                ])
              .toString()
            : "";
      }
    }

    return projectInfo;
  }

  get projectStatusInfo() {
    let projectStatusInfo = "";

    if (!this.clientPanel && !this.deviceOverview) {
      return projectStatusInfo;
    }

    if (this.clientPanel) {
      projectStatusInfo = this.clientPanel.currentProjectName 
        ? this.$t("allDevices.currentProject").toString()
        : this.clientPanel.lastProjectName 
          ? this.$t("allDevices.lastProject").toString()
          : "";
    }
    else {
      projectStatusInfo = this.deviceOverview.currentlyAssigned 
        ? this.$t("allDevices.currentProject").toString()
        : this.deviceOverview.projectName
          ? this.$t("allDevices.lastProject").toString()
          : "";
    }

    return projectStatusInfo;
  }

  get vehicleInfo() {
    let vehicleInfo = "";

    if (!this.vehicle) {
      return vehicleInfo;
    }

    vehicleInfo = this.$t("deviceDetailsDialog.deviceInVehicle", [this.vehicle.vehicleId]).toString();

    return vehicleInfo;
  }

  get showElectricityMeterInfo() {
    const devicePowerUsageType = getDeviceAttributeTypeFromDeviceTemplate(this.deviceTemplate);

    return this.clientPanel
      ? true
      : devicePowerUsageType === DevicePowerUsageType.ELECTRICITY_METER ||
      devicePowerUsageType === DevicePowerUsageType.ELECTRICITY_METER_FOR_OTHER_DEVICES;
  }

  async isInputValid() {
    this.resetErrors();
    let isInputValid = true;

    // Before the uniqueness checks, so they and the save see the stored value.
    this.inventoryNumber = trimDeviceCode(this.inventoryNumber);
    this.qrCode = trimDeviceCode(this.qrCode);

    if (!this.inventoryNumber || this.inventoryNumber === "") {
      this.errorInventoryNumber.push(this.$t("allDevices.errorInventoryNumber").toString());

      isInputValid = false;
    } else {
      const devicesWithInventoryNumber = 
        (await findDevicesWithInventoryNumber(this.inventoryNumber))
        .filter((val) => val.id.toString() !== this.deviceDetails?.id);
      // Only the boxes the client has now, as in the CSV import: the record a box left
      // behind when it moved to another client keeps its old number.
      const clientPanelsWithInventoryNumber = 
        (await findPanelsWithInventoryNumber(this.inventoryNumber))
        .filter((val) => isCurrentClientPanel(val))
        .filter((val) => val.serialNumber.toString() !== this.clientPanel?.serialNumber);

      const isUnique = devicesWithInventoryNumber.length === 0 && clientPanelsWithInventoryNumber.length === 0;
      const isValid = isInventoryNumberValid(this.inventoryNumber);

      if (!isUnique) {
        this.errorInventoryNumber.push(this.$t("allDevices.errorInventoryNumberAlreadyExists").toString());
      } 
      else if (!isValid) {
        this.errorInventoryNumber.push(this.$t("allDevices.errorInventoryNumberInvalid").toString());
      }

      isInputValid = isValid && isUnique;
    }

    if (
      this.canEditPowerConsumptionPerHour &&
      !this.powerConsumptionPerHour && 
      this.powerConsumptionPerHour !== 0 &&
      this.devicePowerUsageType === DevicePowerUsageType.OPERATING_HOURS
    ) {
      this.errorPowerConsumptionPerHourError.push(this.$t("allDevices.errorPowerConsumptionPerHourError").toString());

      isInputValid = false;
    }

    if (!isManufacturerValid(this.manufacturer ?? null)) {
      this.errorInvalidManufacturer.push(this.$t("allDevices.errorInvalidManufacturer").toString());

      isInputValid = false;
    }

    if (!isSerialNumberValid(this.serialNumber ?? "")) {
      this.errorInvalidSerialNumber.push(this.$t("allDevices.errorInvalidSerialNumber").toString());

      isInputValid = false;
    }

    if (!isElectricityMeterManufacturerValid(this.electricityMeterManufacturer ?? null)) {
      this.errorInvalidElectricityMeterManufacturer.push(this.$t("allDevices.errorInvalidElectricityMeterManufacturer").toString());

      isInputValid = false;
    }

    if (!isElectricityMeterNumberValid(this.electricityMeterNumber ?? null)) {
      this.errorInvalidElectricityMeterNumber.push(this.$t("allDevices.errorInvalidElectricityMeterNumber").toString());

      isInputValid = false;
    }

    if (!isNoteValid(this.note ?? null)) {
      this.errorInvalidNote.push(this.$t("allDevices.errorInvalidNote").toString());

      isInputValid = false;
    }

    if (!isQrCodeValid(this.qrCode ?? null)) {
      this.errorInvalidQrCode.push(this.$t("allDevices.errorInvalidQrCode").toString());

      isInputValid = false;
    } else if (this.qrCode && isNotEmpty(this.qrCode)) {
      const devicesWithQrCode = 
        (await findDevicesWithQrCode(this.qrCode))
        .filter((val) => val.id.toString() !== this.deviceDetails?.id);
      // Only the boxes the client has now, as for the inventory number above.
      const clientPanelsWithQrCode =
        (await findPanelsWithQrCode(this.qrCode))
        .filter((val) => isCurrentClientPanel(val))
        .filter((val) => val.serialNumber.toString() !== this.clientPanel?.serialNumber);

      const isUnique = devicesWithQrCode.length === 0 && clientPanelsWithQrCode.length === 0;

      if (!isUnique) {
        this.errorInvalidQrCode.push(this.$t("allDevices.errorQrCodeAlreadyExists").toString());
        isInputValid = false;
      } 
    }

    return isInputValid;
  }

  async onDialogClosed() {
    this.resetDialog();
  }

  get isVehicleManagementEnabled() {
    return getVehicleManagementAccess();
  }

  async onEdit() {
    if (!this.isAllowedToEditDevices) {
      this.onViewDetails(true);
    }
    else if (!this.isEditingDeviceDetails) {
      this.onEditDeviceDetails();
    } else if (this.isForDeviceCreation) {
      this.isLoading = true;
      const isInputValid = await this.isInputValid();

      if (isInputValid) {
        const deviceId = generateRandomUuid();
        const devicesMaxInternalNumber = await getMaxInternalDeviceNumber();

        const powerConsumptionPerHour = this.powerConsumptionPerHour ? parsePowerConsumption(this.powerConsumptionPerHour.toString()) : null;
        const branchNumberString = this.getBranchNumber(this.branch) ?? null;
        const homeLocation = this.getBranchNumber(this.homeLocation) ?? branchNumberString;

        const deviceToBeCreated: GenericDevice = {
          id: deviceId,
          templateId: this.deviceTemplate.id,
          categoryId: this.deviceCategory.id,
          branch: branchNumberString,
          homeLocation: homeLocation,
          internalNumber: devicesMaxInternalNumber + 1,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          inventoryNumber: this.inventoryNumber!!,
          qrCode: this.qrCode ?? null,
          serialNumber: this.serialNumber ?? "",
          manufacturer: this.manufacturer ?? null,
          knownSince: firestore.Timestamp.now(),
          electricityMeterManufacturer: this.electricityMeterManufacturer ?? null,
          availability: this.isAvailableValue ?? 0,
          powerConsumptionPerHour: powerConsumptionPerHour,
          selectedPowerConsumption: selectedPowerConsumptionMode(this.deviceTemplate),
          flaggedAsDeleted: false,
          note: this.note ?? null,
          input: generateInput(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.inventoryNumber!!,
            this.electricityMeterManufacturer,
            undefined,
            this.note,
            powerConsumptionPerHour,
          )
        };

        const deviceOverviews = await saveDevices([deviceToBeCreated], true);

        if (deviceOverviews?.length === 1) {
          this.showingSuccessSnackbar = true;
          this.successSnackbarText = this.$t("allDevices.deviceCreated").toString();
          this.baseDialogComponent.isShowing = false;

          this.$emit("update", false, deviceToBeCreated.id, deviceOverviews[0], true);
        }
        else {
          this.showingErrorSnackbar = true;
          this.errorSnackbarText = this.$t("allDevices.deviceNotCreated").toString();
        }
      }
      else {
        this.showingErrorSnackbar = true;
        this.errorSnackbarText = this.$t("allDevices.deviceNotCreated").toString();
      }

      this.isLoading = false;
    }
    else {
      this.isLoading = true;
      const isInputValid = await this.isInputValid();

      if (isInputValid) {
        const update = filterOutUndefined({
          inventoryNumber: this.inventoryNumber !== this.initialDeviceDetails.inventoryNumber ? this.inventoryNumber : undefined,
          serialNumber: this.serialNumber !== this.initialDeviceDetails.serialNumber ? this.serialNumber : undefined,
          manufacturer: this.manufacturer !== this.initialDeviceDetails.manufacturer ? this.manufacturer : undefined,
          qrCode: this.qrCode !== this.initialDeviceDetails.qrCode ? this.qrCode : undefined,
          electricityMeterManufacturer: this.electricityMeterManufacturer !== this.initialDeviceDetails.electricityMeterManufacturer ? this.electricityMeterManufacturer : undefined,
          acquisitionDate: this.acquisitionDate !== this.initialDeviceDetails.acquisitionDate ? this.acquisitionDate : undefined,
          lastCheck: this.lastCheckAt !== this.initialDeviceDetails.lastCheckAt ? {
            recordedAt: this.lastCheckAt,
            recordedByUserId: this.activeUser?.id ?? ""
          } : undefined,
          nextCheck: this.nextCheck !== this.initialDeviceDetails.nextCheck ? this.nextCheck : undefined,
          availability: this.isAvailableValue !== this.initialDeviceDetails.isAvailableValue ? this.isAvailableValue : undefined,
          branch: this.branch !== this.initialDeviceDetails.branch ? this.getBranchNumber(this.branch) : undefined,
          homeLocation: this.homeLocation !== this.initialDeviceDetails.homeLocation ? this.getBranchNumber(this.homeLocation) : undefined,
          note: this.note !== this.initialDeviceDetails.note ? this.note : undefined,
          powerConsumptionPerHour: this.powerConsumptionPerHour !== this.initialDeviceDetails.powerConsumptionPerHour ? this.powerConsumptionPerHour : undefined
        });

        // If the vehicle management is not enabled, we shouldn't differentiate between home location and current location
        if (!this.isVehicleManagementEnabled && this.homeLocation) {
          update["branch"] = this.getBranchNumber(this.homeLocation);
        }

        const vehicleId = this.clientPanel
          ? this.clientPanel.vehicleId
          : this.deviceDetails?.vehicleId;

        let isDeletionSuccessful = true;
        if (update.availability && update.availability === -1) {
          update.vehicleId = null;

          const deletedInventoryNumber = (
            await getUpdatedIdsAfterDeletion(
              this.inventoryNumber ? [this.inventoryNumber] : [""],
              "inventoryNumber",
              this.clientPanel ? getClientPanelsRef() : getClientDevicesRef()
            )
          ).get(this.inventoryNumber ?? "");

          if (deletedInventoryNumber === undefined) {
            isDeletionSuccessful = false;
          }

          update.inventoryNumber = deletedInventoryNumber ?? "";

          // The QR code is released with it, so the label can go on another device.
          const releasedQrCode = await getReleasedQrCode(
            this.qrCode,
            this.clientPanel ? getClientPanelsRef() : getClientDevicesRef()
          );

          if (releasedQrCode === "") {
            isDeletionSuccessful = false;
          } else if (releasedQrCode) {
            update.qrCode = releasedQrCode;
          }
        }

        if (isDeletionSuccessful) {
          const deviceId = this.clientPanel
            ? this.clientPanel.serialNumber
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            : this.deviceDetails!!.id;

          const [isSuccess] = await Promise.all([
            this.clientPanel
              ? updateClientPanel(this.clientPanel.serialNumber, update)
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              : updateDeviceById(this.deviceDetails!.id, update),
            ...(vehicleId ? [removeDeviceFromVehicle(vehicleId, deviceId)] : [])
          ]);

          if (isSuccess) {
            this.showingSuccessSnackbar = true;
            this.successSnackbarText = this.$t("common.changesSaved").toString();
            this.baseDialogComponent.isShowing = false;

            this.$emit("update", this.clientPanel ? true : false, this.clientPanel ? this.clientPanel.serialNumber : this.deviceDetails?.id, update);
          }
          else {
            this.showingErrorSnackbar = true;
            this.errorSnackbarText = this.$t("common.changesNotSaved").toString();
          }
        }
        else {
          this.showingErrorSnackbar = true;
          this.errorSnackbarText = this.$t("common.changesNotSaved").toString();
        }   
      }
      else {
        this.showingErrorSnackbar = true;
        this.errorSnackbarText = this.$t("common.changesNotSaved").toString();
      }

      this.isLoading = false;
    }
  }

  async onOpenProject() {
    if (this.projectId) {
      localStorage.setItem(this.currentlyOpenedDeviceKey, this.clientPanel ? this.clientPanel.serialNumber : this.deviceOverview.inventoryNumber);
      localStorage.setItem(this.isReadOnlyKey, this.isReadOnly ? "true" : "false");

      if (this.searchQuery && this.searchQuery !== "") {
        localStorage.setItem(this.searchQueryKey, this.searchQuery);
      }

      router.push({
        path: `/main/projects/${this.projectId}`,
        params: {
          projectId: this.projectId,
        },
      });
    }

    return;
  }

  async onOpenVehicle() {
    if (this.vehicleId) {
      localStorage.setItem(this.currentlyOpenedDeviceKey, this.clientPanel ? this.clientPanel.serialNumber : this.deviceOverview.inventoryNumber);
      localStorage.setItem(this.isReadOnlyKey, this.isReadOnly ? "true" : "false");

      if (this.searchQuery && this.searchQuery !== "") {
        localStorage.setItem(this.searchQueryKey, this.searchQuery);
      }

      router.push({
        path: `/main/vehicleDevices?vehicleId=${this.vehicleId}`,
        query: {
          isReadOnly: "true",
        },
      });
    }

    return;
  }

  async onOpenHistory() {
    localStorage.setItem(this.currentlyOpenedDeviceKey, this.clientPanel ? this.clientPanel.serialNumber : this.deviceOverview.inventoryNumber);
    localStorage.setItem(this.isReadOnlyKey, this.isReadOnly ? "true" : "false");

    if (this.searchQuery && this.searchQuery !== "") {
        localStorage.setItem(this.searchQueryKey, this.searchQuery);
      }

    if (this.clientPanel) {
      router.push({
        path: `/main/allDevices/dryingHistory`,
        query: {
          serialNumber: this.clientPanel.serialNumber.toUpperCase(),
        },
      });
    }
    else {
      router.push({
        path: `/main/allDevices/deviceHistory`,
        query: {
          deviceId: this.deviceOverview.id,
        },
      });
    }
  }

  async onViewDetails(toDeviceDetail?: boolean) {
    if (this.clientPanel && (this.isAllowedToEditDevices || toDeviceDetail) && this.isDeviceDetailAvailable) {
      localStorage.setItem(this.isReadOnlyKey, this.isReadOnly ? "true" : "false");
      localStorage.setItem(this.currentlyOpenedDeviceKey, this.clientPanel.serialNumber);

      if (this.searchQuery && this.searchQuery !== "") {
        localStorage.setItem(this.searchQueryKey, this.searchQuery);
      }

      router.push({
        path: `/main/devices/deviceDetail`,
        query: {
          serialNumber: this.clientPanel.serialNumber.toUpperCase(),
        },
      });
    }
    else {
      this.onOpenHistory();
    }
  }

  calculatePositiveButtonText() {
    return this.isReadOnly
      ? this.isAllowedToEditDevices
        ? this.editButtonText
        : this.clientPanel && this.isDeviceDetailAvailable
          ? this.detailsButtonText
          : this.isHistoryAvailable
            ? this.historyButtonText
            : ""
      : this.isForDeviceCreation
        ? this.saveButtonText
        : this.isHistoryAvailable
          ? this.historyButtonText
          : ""
  }

  calculateNegativeButtonText() {
    return this.isReadOnly
      ? this.closeButtonText
      : this.cancelButtonText;
  }

  calculateNeutralPositiveButtonText(positiveButtonText: string) {
    const isHistoryButtonAlreadyAddded = positiveButtonText === this.historyButtonText

    return this.isReadOnly
      ? this.isAllowedToEditDevices
        ? this.clientPanel && this.isDeviceDetailAvailable
          ? this.detailsButtonText
          : this.isHistoryAvailable && !isHistoryButtonAlreadyAddded
            ? this.historyButtonText
            : ""
        : this.clientPanel
          ? this.isHistoryAvailable && !isHistoryButtonAlreadyAddded
            ? this.historyButtonText
            : ""
          : ""
      : "";
  }

  calculateAdditionalNeutralPositiveButtonText(
    positiveButtonText: string,
    neutralPositiveButtonText: string
  ) {
    const isHistoryButtonAlreadyAddded = positiveButtonText === this.historyButtonText || 
      neutralPositiveButtonText === this.historyButtonText;

    return this.isReadOnly
      ? !isHistoryButtonAlreadyAddded
        ? this.isHistoryAvailable
            ? this.historyButtonText
            : ""
        : ""
      : "";
  }
   
  async show(
    title: string, 
    deviceDetails: GenericDevice | null,
    deviceAssignments: GenericDeviceProjectAssignment[],
    vehicle?: Vehicle,
    isForDeviceCreation?: boolean,
    hideOpenVehicleButton?: boolean,
  ) {
    this.title = title;
    this.isForDeviceCreation = isForDeviceCreation ?? false;
    this.vehicle = vehicle ?? null;
    this.hideOpenVehicleButton = hideOpenVehicleButton ?? false;

    const isAssignedToProject = this.deviceOverview?.currentlyAssigned || this.clientPanel?.currentProjectId;

    if (this.isForDeviceCreation || isAssignedToProject) {
      this.availabilityOptions = [0, 1];
    }

    this.deviceDetails = deviceDetails;
    
    this.deviceAssignments = deviceAssignments.sort((a, b) => {
      const dateA = a.assignmentEndDate ? timestampToDate(a.assignmentEndDate) : null;
      const dateB = b.assignmentEndDate ? timestampToDate(b.assignmentEndDate) : null;

      if (dateA === null && dateB === null) {
        return 0;
      } else if (dateA === null) {
        return -1;
      } else if (dateB === null) {
        return 1
      }

      return dateB.getTime() - dateA.getTime();
    });

    const positiveButtonText = this.calculatePositiveButtonText();
    const negativeButtonText = this.calculateNegativeButtonText();
    const neutralPositiveButtonText = this.calculateNeutralPositiveButtonText(positiveButtonText);
    const additionalNeutralPositiveButtonText = this.calculateAdditionalNeutralPositiveButtonText(
        positiveButtonText,
        neutralPositiveButtonText
      );

    this.baseDialogComponent.show({
      title: this.title,
      positiveButtonText: positiveButtonText,
      negativeButtonText: negativeButtonText,
      neutralPositiveButtonText: neutralPositiveButtonText,
      additionalNeutralPositiveButtonText: additionalNeutralPositiveButtonText,
      closeOnSave: false,
      closeOnNeutralAction: false,
      closeOnNeutralPositiveAction: false,
      maxWidth: 1200,
      hidePositiveButtonIfEmpty: true,
      hideSaveButton: positiveButtonText === ""
    });

    this.restoreIntialValues();

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  formatAvailabilityOptions(value: number) {
    return this.$t(`allDevices.${value === -1 ? "deleted" : value === 0 ? "available" : "notAvailable"}`).toString();
  }

  getBranchId(branchNumber: string | number | null | undefined) {
    if (!branchNumber) {
      return null;
    }

    const branches = getBranchesOfClient();
    const deviceBranch = branches.filter(branch => branchNumber.toString() === branch.branchNumber.toString());

    if (deviceBranch.length === 1) {
      return deviceBranch[0].id;
    }

    return null;
  }

  getBranchNumber(branchId: string | null | undefined) {
    if (!branchId) {
      return null;
    }

    const branches = getBranchesOfClient();
    const deviceBranch = branches.filter(branch => branchId === branch.id.toString());

    if (deviceBranch.length === 1) {
      return deviceBranch[0].branchNumber.toString();
    }

    return null;
  }

  async onAbortEditDeviceDetails() {
    if (this.isEditingDeviceDetails) {
      if (this.hasDetailsEdited) {
        const result = await this.confirmationDialogComponent.show({
          title: this.$t("common.confirmationDialog.cancelTitle").toString(),
          message: this.$t("common.confirmationDialog.cancelMessage").toString(),
        });

        if (result) {
          this.onAbortEditDeviceDetailsConfirmed();
        }
      }
      else {
        this.onAbortEditDeviceDetailsConfirmed();
      }
    }
  }

  onAbortEditDeviceDetailsConfirmed() {
    if (this.isForDeviceCreation) {
      this.baseDialogComponent.isShowing = false;
    }

    this.isReadOnly = true;

    const positiveButtonText = this.calculatePositiveButtonText();
    const neutralPositiveButtonText = this.calculateNeutralPositiveButtonText(positiveButtonText);

    this.baseDialogComponent.neutralPositiveButtonText = neutralPositiveButtonText;
    this.baseDialogComponent.positiveButtonText = positiveButtonText;
    this.baseDialogComponent.additionalNeutralPositiveButtonText = this.calculateAdditionalNeutralPositiveButtonText(
        positiveButtonText,
        neutralPositiveButtonText
      );
    this.baseDialogComponent.negativeButtonText = this.closeButtonText;
    this.baseDialogComponent.persistent = false;

    this.preventClosingDialog = false;
    this.isEditingDeviceDetails = false;
    this.restoreIntialValues();
  }

  onEditDeviceDetails() {
    this.isReadOnly = false;

    this.baseDialogComponent.neutralPositiveButtonText = "";
    this.baseDialogComponent.additionalNeutralPositiveButtonText = "";
    this.baseDialogComponent.positiveButtonText = this.saveButtonText;
    this.baseDialogComponent.negativeButtonText = this.cancelButtonText;
    this.baseDialogComponent.persistent = true;

    this.preventClosingDialog = true;
    this.isEditingDeviceDetails = true;

    if (
      this.deviceCode === this.$t("allDevices.qrCodeNotStored").toString() ||
      this.deviceCode === this.$t("allDevices.noQrCode").toString()
    ) {
      this.deviceCode = "";
    }
  }

  resetDialog() {
    this.isReadOnly = true;
    this.preventClosingDialog = false;
    this.isEditingDeviceDetails = false;
  }

  resetErrors() {
    this.errorInventoryNumber = [];
    this.errorPowerConsumptionPerHourError = [];
    this.errorInvalidQrCode = [];
    this.errorInvalidManufacturer = [];
    this.errorInvalidSerialNumber = [];
    this.errorInvalidElectricityMeterManufacturer = [];
    this.errorInvalidElectricityMeterNumber = [];
    this.errorInvalidNote = [];
  }

  restoreIntialValues() {
    this.resetErrors();

    if (this.isForDeviceCreation) {
      this.onEditDeviceDetails();
    }

    const source = this.clientPanel || this.deviceDetails;

    this.inventoryNumber = source?.inventoryNumber;
    this.serialNumber = source?.serialNumber;
    this.manufacturer = this.clientPanel ? getIresDeviceManufacturer() : source?.manufacturer;
    this.qrCode = source?.qrCode;
    this.deviceCode = this.qrCode
      ? this.qrCode
      : this.isEditingDeviceDetails
        ? ""
        : this.$t(this.clientPanel ? "allDevices.noQrCode" : "allDevices.qrCodeNotStored").toString();
    this.electricityMeterManufacturer = this.clientPanel ? getIresDeviceElectricityMeterManufacturer() : source?.electricityMeterManufacturer;
    this.electricityMeterNumber = source?.electricityMeterNumber || "";
    this.acquisitionDate = source?.acquisitionDate;
    this.lastCheckAt = source?.lastCheck?.recordedAt;
    this.nextCheck = source?.nextCheck;
    this.isAvailableValue = !this.isForDeviceCreation && this.isDeviceDeleted ? -1 : this.isAvailable ? 0 : 1;
    this.branch = this.getBranchId(source?.branch);
    this.homeLocation = this.getBranchId(source?.homeLocation) ?? this.branch;
    this.note = source?.note ?? "";
    this.powerConsumptionPerHour = this.clientPanel ? getIresDevicePowerConsumptionPerHour(this.serialNumber) : source?.powerConsumptionPerHour

    if (!this.clientPanel) {
      this.canEditSerialNumber = true;
      this.canEditManufacturer = true;
      this.canEditElectricityMeterManufacturer = true;

      this.canEditPowerConsumptionPerHour = this.devicePowerUsageType === DevicePowerUsageType.OPERATING_HOURS || this.devicePowerUsageType === DevicePowerUsageType.NONE;
    }

    if (this.isForDeviceCreation && !this.powerConsumptionPerHour && this.powerConsumptionPerHour !== 0) {
      const powerConsumptionPerHour = this.deviceTemplate.deviceAttributes.find(
        (attribute) => attribute.attributeType === DeviceAttributeType.POWER_CONSUMPTION_PER_HOUR)
      ?.defaultValue;
      if (powerConsumptionPerHour) {
        this.powerConsumptionPerHour = parsePowerConsumption(powerConsumptionPerHour);
      }
    }

    this.initialDeviceDetails = {
      inventoryNumber: this.inventoryNumber,
      serialNumber: this.serialNumber,
      manufacturer: this.manufacturer,
      qrCode: this.qrCode,
      electricityMeterManufacturer: this.electricityMeterManufacturer,
      acquisitionDate: this.acquisitionDate,
      lastCheckAt: this.lastCheckAt,
      nextCheck: this.nextCheck,
      isAvailableValue: this.isAvailableValue,
      branch: this.branch,
      homeLocation: this.homeLocation ?? this.branch, 
      note: this.note,
      powerConsumptionPerHour: this.powerConsumptionPerHour,
    }
  }

  mounted() {
    const cachedIsReadOnly = localStorage.getItem(this.isReadOnlyKey);

    if (cachedIsReadOnly) {
      this.isReadOnly = cachedIsReadOnly === "true";
      
      if (!this.isReadOnly) {
        this.onEditDeviceDetails();
      }

      localStorage.removeItem(this.isReadOnlyKey);
    }
  }
}
